<template>
  <div class="card mb-3" style="min-height: 60vh;">
      <a-drawer v-if="account != null" :visible="showDrawerViewDetails" :width="600" placement="right" @close="onClose">
        <h6 class="heading-small text-muted">Account Basic Information</h6><br>
        <div  class="col-xl-12 col-lg-12">
          <stats-card :title="account.company_name"
            type="gradient-green"
            :sub-title="account.account_name"
            icon="ni ni-building"
            class="mb-4 mb-xl-0">
            <template slot="footer">
              <span class="mr-2"> Status: {{account.status}} </span> <br>
              <span class="mr-2"> Created: {{account.created_at | dateFilter}}  </span> <br>
              <span class="account-type-container">
                <div class="account-label-container">Account Type :</div>
                  <a-select v-model="selectedAccountType" style="width: 65%">
                    <a-select-option  v-for="(account_type, index) in accountTypes"
                      :key="index"
                      :value="account_type.id">
                      {{ account_type.name }}
                    </a-select-option>
                  </a-select>
                  </span>
                  <br>
                        <span class="account-type-container">
                            <div class="account-label-container">
                                Costing Method:
                            </div>
                            <a-select
                              v-model="accountCredentials.documentCostingMethod"
                              style="width: 65%"
                              :disabled="accountCredentials.costingStatus != '0' && accountCredentials['costingStatus'] !== undefined"
                              @change="setCostingMethod(account.id)">
                              <a-select-option  v-for="(costing_method, index) in costingMethodOptions"
                                   :key="index"
                                   :value="costing_method.id">
                                  {{ costing_method.value }}
                              </a-select-option>
                            </a-select>
                        </span>
                        <span class="mr-2 text-danger" v-if="accountCredentials.costingStatus != '0' && accountCredentials['costingStatus'] !== undefined">Status: {{accountCredentials.costingStatus}}</span>
                  <br>
                  <!-- add tier number dropdown for account editing -->
                  <span class="account-type-container">
                    <div class="account-label-container">Tier Number:</div>
                    <a-select v-model="selectedTierNumber" style="width: 65%">
                      <a-select-option
                        v-for="(tier_no, index) in tierNumbers"
                        :key="index"
                        :value="tier_no"
                      >
                        {{ tier_no }}
                      </a-select-option>
                    </a-select>
                  </span>
                  <br>
                  <span class="account-type-container">
                    <div class="account-label-container">Max Concurrent Sessions:</div>
                    <input type="number" v-model="maxConcurrentSession" min="1" class="form-control" style="width: 65%" />
                  </span>
                  <br>
                  <span class="account-type-container">
                <div class="account-label-container">Enable Site Pricing : <br>
                  <input type="radio" name="no" value="false" v-model="sitePricingEnabled"/><span style="margin:0 15px 0 1px;">No</span> 
                  <input type="radio" name="yes" value="true" v-model="sitePricingEnabled"/><span style="margin:0 15px 0 1px;">Yes</span>
                </div>
              </span> <br>
                  <span class="account-type-container">
                <div class="account-label-container">Enable BIR CAS : <br>
                  <input type="radio" name="casNo" value="false" v-model="casEnabled"/><span style="margin:0 15px 0 1px;">No</span>
                  <input type="radio" name="casYes" value="true" v-model="casEnabled"/><span style="margin:0 15px 0 1px;">Yes</span>
                </div>
              </span> <br>
                  <span class="account-type-container">
                <div class="account-label-container">Allow Non-HO Product Site Editing : <br>
                  <input type="radio" name="non-ho-edit-no" value="false" v-model="allowNonHoProductSiteEditing"/><span style="margin:0 15px 0 1px;">No</span>
                  <input type="radio" name="non-ho-edit-yes" value="true" v-model="allowNonHoProductSiteEditing"/><span style="margin:0 15px 0 1px;">Yes</span>
                </div>
              </span> <br>
                  <span class="account-type-container">
                <div class="account-label-container">Show Other Site Prices In Non-HO Edit : <br>
                  <input type="radio" name="non-ho-other-site-prices-no" value="false" v-model="showOtherSitePricesInNonHoEdit"/><span style="margin:0 15px 0 1px;">No</span>
                  <input type="radio" name="non-ho-other-site-prices-yes" value="true" v-model="showOtherSitePricesInNonHoEdit"/><span style="margin:0 15px 0 1px;">Yes</span>
                </div>
              </span> <br>
                  <span class="account-type-container">
                <div class="account-label-container">Enable Site-Product Price Decoupling : <br>
                  <input type="radio" name="siteProductPriceDecouplingNo" value="false" v-model="siteProductPriceDecouplingEnabled"/><span style="margin:0 15px 0 1px;">No</span>
                  <input type="radio" name="siteProductPriceDecouplingYes" value="true" v-model="siteProductPriceDecouplingEnabled"/><span style="margin:0 15px 0 1px;">Yes</span>
                </div>
              </span> <br>
                  <span class="mr-2">
                    <base-input alternative="" label="Netsuite ID :" placeholder="Netsuite ID " v-model="account.ns_id" input-classes="form-control" />
                  </span>

                  <span class="account-type-container" style="margin-top: 10px;">
                    <div class="account-label-container" style="width: 100%;">
                      EOD Report Requirements:
                      <div style="margin-top: 5px; font-weight: normal;">
                        <label style="display: flex; align-items: center; margin-bottom: 5px; cursor: pointer;">
                          <input type="checkbox" v-model="accountCredentials.requireZReading" style="margin-right: 8px;" />
                          Require ZReading before generating EOD by Cashier and POS Report
                        </label>
                        <label style="display: flex; align-items: center; margin-bottom: 5px; cursor: pointer;" :style="{ opacity: accountCredentials.requireZReading ? 1 : 0.5 }">
                          <input type="checkbox" v-model="accountCredentials.requireRmsDeclaration" :disabled="!accountCredentials.requireZReading" style="margin-right: 8px;" />
                          Require RMS Declaration before generating EOD by Cashier and POS Report
                        </label>
                      </div>
                    </div>
                  </span>
                  <br>

                  <span class="account-type-container" style="margin-top: 10px;">
                    <div class="account-label-container" style="width: 100%;">
                      Receiving Document:
                      <div style="margin-top: 5px; font-weight: normal;">
                        <label style="display: flex; align-items: center; margin-bottom: 5px; cursor: pointer;">
                          <input type="checkbox" v-model="accountCredentials.enableIntactCostLayerValidationOnVoid" style="margin-right: 8px;" />
                          Enable Validation For Intact Cost Layer When Voiding
                        </label>
                      </div>
                    </div>
                  </span>
                  <br>

                  <button type="button" class="btn btn-sm btn-info float-right mr-2" style="width: 25%" @click.prevent="setUpdate(account.id)">Update</button> 
            </template>
            </stats-card>

            <br><br>

            <a-tabs v-model="activeKey" type="card">
              <a-tab-pane tab="Company Details" key="1">
                <div class="col-md-12">
                  <h6 class="heading-small text-muted">COMPANY NAME</h6>
                  {{account.company_name}} <br><br>

                  <h6 class="heading-small text-muted">TIN NUMBER</h6>
                  {{account.companyTinNumber}} <br><br>

                  <h6 class="heading-small text-muted">ADDRESS</h6>
                  {{account.companyAddress}} <br><br>

                  <h6 class="heading-small text-muted">CONTACT NUMBER</h6>
                  {{account.telephone_no}} <br><br>
                </div>
              </a-tab-pane>
              <a-tab-pane tab="Sites" key="2">
                <table class="table table-sm">
                  <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Billing Type</th>
                  </tr>
                  <tr v-for="site in account.sites" :key="site.id">
                    <td>{{site.name}}</td>
                    <td>{{site.status}}</td>
                    <td>
                      <a-select v-model="site.billing_type_id"
                        style="width: 100%"
                        @change="setBillingType(account.id, site.billing_type_id, site.id)">
                        <a-select-option  v-for="(billing_type, index) in billingTypes"
                          :key="index"
                          :value="billing_type.id">
                          {{ billing_type.name }}
                        </a-select-option>
                      </a-select>
                    </td>
                  </tr>
                </table>
              </a-tab-pane>
              <a-tab-pane tab="Users" key="3">
                <table class="table table-sm">
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Status</th>
                  </tr>
                  <tr v-for="user in account.users" :key="user.id">
                    <td>{{user.name}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.status}}</td>
                  </tr>
                </table>
              </a-tab-pane>
            </a-tabs>
        </div>
          
        <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
          <button type="button" class="btn btn-sm btn-danger float-right" style="width: 25%">Delete</button> 
          <button v-if="account.status == 'A'" type="button" class="btn btn-sm btn-warning float-right mr-3" style="width: 25%" @click.prevent="updateAccountStatus(account.id, 'S')">Suspend</button> 
          <button v-if="account.status == 'S'" type="button" class="btn btn-sm btn-success float-right mr-3" style="width: 25%" @click.prevent="updateAccountStatus(account.id, 'A')">Activate</button> 
        </div>
      </a-drawer>

      <a-drawer :visible="showDrawer" :width="480" placement="right" @close="onClose">
        ADD ACCOUNT
        <form id="form-proper">
          <a-spin :spinning="loading" tip="Creating account...">
            <br>
            <h6 class="heading-small text-muted">Basic Information</h6>
            <base-input alternative="" label="Account Name" placeholder="Account Name" v-model="accountName" input-classes="form-control" required />
            <base-input alternative="" label="Account Type" input-classes="form-control" required>
              <a-select v-model="accountType" 
                placeholder="Select Account Type"
                @change="getSelectedAccountType">
                <a-select-option  v-for="list in accountTypes"
                  :key="list.id"
                  :value="list.id">{{ list.name }}
                </a-select-option>
              </a-select>
            </base-input>
            
            <base-input alternative="" label="Company Name" placeholder="Company Name" v-model="companyName" input-classes="form-control" required />
            <base-input alternative="" label="Account Templates" input-classes="form-control" required>
              <a-select  v-model="accountTemplate" 
                placeholder="Select Account Template"
                @change="getSelectedAccountTemplate">
                <a-select-option v-for="list in account_templates_list"
                :key="list.id"
                :value="list.id">{{ list.name }}
                </a-select-option>
              </a-select>
            </base-input>

            <base-input alternative="" label="Business Type" input-classes="form-control" required>
              <a-select  v-model="businessType"
                placeholder="Select Business Type"
                @change="getSelectedBusinessType">
                  <a-select-option v-for="list in system_business_type_list"
                  :key="list.id"
                  :value="list.id"
                  >{{ list.name }}
                  </a-select-option>
              </a-select>
            </base-input>
            <base-input alternative="" label="Costing Method" input-classes="form-control" required>
                  <a-select  v-model="accountCredentials.documentCostingMethod"
                    placeholder="Select Costing Method"
                    @change="getSelectedCostingMethod">
                        <a-select-option
                        v-for="list in costingMethodOptions"
                        :key="list.id"
                        :value="list.id"
                        >{{ list.value }}
                        </a-select-option>
                    </a-select>
            </base-input>
            <!-- add tier number dropdown list for adding an account -->
            <base-input alternative="" label="Tier Number" input-classes="form-control" required>
              <a-select v-model="tierNumber"
                placeholder="Select Tier Number"
                @change="getSelectedATierNumber">
                <a-select-option
                  v-for="(tierNumber, index) in tierNumbers"
                  :key="index"
                  :value="tierNumber"
                >
                  {{ tierNumber }}
                </a-select-option>
              </a-select>
            </base-input>
            <base-input alternative="" label="TIN Number" placeholder="TIN Number" v-model="companyTinNumber" input-classes="form-control" required />
            <base-input alternative="" label="Company Address" placeholder="Company Address"  v-model="companyAddress" input-classes="form-control" required />
            <h4 input-classes="form-control" >Site Pricing *</h4>
            <base-checkbox v-model="enableSitePrice" > Enable Site Pricing </base-checkbox> <br>

            <h6 class="heading-small text-muted">Contact Information</h6>
            <base-input label="Owner Name" required>
                <div class="form-group row">
                    <div class="col-sm-6" style="padding-right: 3px">
                        <input type="text" class="form-control" placeholder="First Name" v-model="firstName">
                    </div>
                    <div class="col-sm-6" style="padding-left: 3px">
                        <input type="text" class="form-control" placeholder="Last Name" v-model="lastName">
                    </div>
                </div>
            </base-input>

            <base-input alternative="" label="Contact Number" placeholder="" input-classes="form-control" type="number" v-model="contactNumber" required />

            <h6 class="heading-small text-muted">Login Information</h6>
            <base-input alternative="" label="Username" placeholder="" input-classes="form-control" v-model="userName" required/>
              <base-input alternative="" label="Email Address" placeholder="" input-classes="form-control" v-model="emailAddress" required/>
              <base-input alternative="" label="Email Address Confirmation" placeholder="" input-classes="form-control" v-model="emailAddressConfirmation" required />
              <base-input alternative="" label="Password" placeholder="" input-classes="form-control" required type="password" v-model="password"/>
              <base-input alternative="" label="Password Confirmation" placeholder="" input-classes="form-control" required type="password" v-model="passwordConfirmation"/>


              <button type="button" class="btn btn-sm btn-secondary float-right" @click.prevent="onClose">Close</button> 
              <button type="button" class="btn btn-sm btn-primary float-right mr-3" @click.prevent="createAccount">Create</button> 
            <br>
          </a-spin>
        </form>
      </a-drawer>

      <div style="min-height: 60vh;">
        <div class="card-body">
          <div class="row">
              <div class="col-md-2">
                <h2>Account List</h2>
              </div>
              <div class="col-md-8">
                <input
                  type="text"
                  v-model="searchQuery"
                  @input="search"
                  class="form-control mr-sm-2 mb-sm-3"
                  id="searchInput"
                  placeholder="Search Name"
                  style="width:50%;"
                >    
              </div>
              <div class="col-md-2"><button class="btn btn-sm btn-default float-right" @click.prevent="addAccount">+ Add Account</button></div>
              <div class="table-responsive" >
                  <vuetable  
                    ref="vuetable" 
                    :api-url="apiURL" 
                    :http-options="httpOptions" 
                    :fields="fields" 
                    :show-sort-icons="true" 
                    :per-page="10" 
                    :css="css.table" 
                    pagination-path="" data-path="data"
                    @vuetable:load-error="onLoadError" 
                    @vuetable:pagination-data="onPaginationData"
                    :search="searchQuery"
                  >
          
                  <template slot="actions" slot-scope="props">
                      <!-- {{props}} -->
                  <!-- <template slot="actions"> -->
                    <center>
                      <button class="btn btn-success btn-sm" @click.prevent="showAccountDetails(props.rowData.id)">Update Details</button>&nbsp;&nbsp;
                    </center>
                  </template>
          
                </vuetable>
              </div>
              
              <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
                <div class="pagination ui basic segment grid">
                  <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
                  </vuetable-pagination>
                </div>
              </div>

          </div>
        </div>
      </div>
  </div>
</template>

<script>
import ValidateField from '../../components/validateFormUtils.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import secureStorage from '../../controllers/secureStorage';
import { mapState, mapActions } from 'vuex'
import moment from 'moment';

const getNotificationStyle = type => {
        return {
            success: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #b7eb8f',
                backgroundColor: '#f6ffed'
            },
            warning: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffe58f',
                backgroundColor: '#fffbe6'
            },
            error: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffa39e',
                backgroundColor: '#fff1f0'
            },
            info: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #91d5ff',
                backgroundColor: '#e6f7ff'
            }
        }[type]
    }

export default {
  components: {
      Vuetable,
      VuetablePagination
  },
  computed: {
      ...mapState(['endPoint', 'profileId', 'serverType']),
  },
  data () {
      return {
          currentCostingMethod: null,
          accountCredentials: {},
          costingMethodOptions: [
              {id: "FIFO", value: "FIFO"},
              {id: "LIFO", value: "LIFO"},
              {id: "AVERAGE", value: "AVERAGE"},
              {id: "BLENDED", value: "BLENDED AVERAGE"}
            ],
          loading: false,
          accountTypes:[],
          selectedAccountType:'',
          billingTypes:[],
          activeKey: "1",
          account: null,
          accountType: undefined,
          type: "dark",
          showDrawer: false,
          showDrawerViewDetails: false,
          accountName: null,
          companyName: null,
          firstName: null,
          lastName: null,
          userName: null,
          contactNumber: null,
          emailAddress: null,
          userName: null,
          password: null,
          searchQuery: null,
          emailAddressConfirmation: null,
          passwordConfirmation: null,
          companyAddress: null,
          companyTinNumber: null,
          tierNumber: undefined,
          selectedTierNumber: '',
          tierNumbers: [1, 2, 3, 4, 5], // add tierNumbers to store the options for dropdown list
          businessType: undefined,
          system_business_type_list: [],
          accountTemplate:undefined,
          account_templates_list:[],
          fields: [{name: "account_name", title: "Account Name"}, 
                {name: "company_name", title: "Company Name"}, 
                {name : "created_at", title: "Create Date"},
                '__slot:actions'],
          httpOptions: {
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            }
          },
          apiURL: "",
          css: {
            table: {
              tableClass: 'table table-sm table-striped table-bordered table-hovered',
              loadingClass: 'loading'
            },
            pagination: {
              infoClass: 'pull-right',
              wrapperClass: 'vuetable-pagination pull-right',
              activeClass: 'btn-primary btn-sm',
              disabledClass: 'disabled',
              pageClass: 'btn btn-border',
              linkClass: 'btn btn-border',
              icons: {
                first: '',
                prev: '',
                next: '',
                last: '',
              },
            }
          },
          errors: [],
          enableSitePrice:false,
          sitePricingEnabled:false,
          casEnabled:false,
          siteProductPriceDecouplingEnabled:'false',
          maxConcurrentSession: 5,
          allowNonHoProductSiteEditing:false,
          showOtherSitePricesInNonHoEdit:'true',
          // accountCredentials:null
      }
  },
  mounted: function () {
      this.apiURL = this.endPoint + "/accounts"
      this.getSystemBusinessType();
      this.getAccountTemplates();
      this.getAccountTypes();
      this.getBillingTypes();
  },
  filters: {
    dateFilter: function (timestamp) {
      return moment(timestamp).format('L LTS')
    }
  },
  watch: {
    // bryan
    enableSitePrice: async function (){
      console.log(this.enableSitePrice)
    },
    'accountCredentials.requireZReading': function(newVal) {
      if (!newVal) {
        this.$set(this.accountCredentials, 'requireRmsDeclaration', false);
      }
    }
  },
  methods: { 
    ...mapActions(['updateProfileId']),
      moment,
    // bryan
      async getSitePricing(account_id){
        var credentials = await HTTPRequest.getRequest(this.endPoint + `settings/accountSettings?field_name=code&account_id=${account_id}` , null)
        this.accountCredentials = JSON.parse(credentials.value)
         this.sitePricingEnabled = this.accountCredentials.sitePricingEnabled? 'true' : 'false'
         this.casEnabled = (this.accountCredentials && this.accountCredentials.casEnabled) ? 'true' : 'false'
         this.siteProductPriceDecouplingEnabled = (this.accountCredentials && this.accountCredentials.siteProductPriceDecouplingEnabled) ? 'true' : 'false'
         this.allowNonHoProductSiteEditing = this.accountCredentials.allowNonHoProductSiteEditing ? 'true' : 'false'
         this.showOtherSitePricesInNonHoEdit = this.accountCredentials.showOtherSitePricesInNonHoEdit === false ? 'false' : 'true'
      },
      async getAccountTypes(){
        this.accountTypes = await HTTPRequest.getRequest(`${this.endPoint}/account_types`, null, null) 
      },
      async getBillingTypes(){
        this.billingTypes = await HTTPRequest.getRequest(`${this.endPoint}/billing_types`, null, null) 
      },
      showTerminalSelectionDrawer(id){
        this.showTerminalSelection = true
      },
      async setUpdate(account_id){
        let params = { 'account_type_id': this.selectedAccountType, 'ns_id': this.account.ns_id, 'tier_no': this.selectedTierNumber }
        // bryan
        let sitePricingEnabled = this.sitePricingEnabled == 'true'? true : false
        let allowNonHoProductSiteEditing = this.allowNonHoProductSiteEditing == 'true' ? true : false
        let showOtherSitePricesInNonHoEdit = this.showOtherSitePricesInNonHoEdit == 'true' ? true : false
        this.accountCredentials.sitePricingEnabled = sitePricingEnabled
        this.accountCredentials.casEnabled = this.casEnabled == 'true'? true : false
        this.accountCredentials.siteProductPriceDecouplingEnabled = this.siteProductPriceDecouplingEnabled == 'true' ? true : false
        this.accountCredentials.allowNonHoProductSiteEditing = allowNonHoProductSiteEditing
        this.accountCredentials.showOtherSitePricesInNonHoEdit = showOtherSitePricesInNonHoEdit
        let setting_params = { account_id, code:'accountSettings', value:JSON.stringify(this.accountCredentials)}
        await HTTPRequest.postRequest(`${this.endPoint}/settings/update_setting_by_admin`, null, setting_params) 

        // Update max concurrent session setting
        let maxSessionParams = { account_id, code: 'max_concurrent_ho', name: 'Max Concurrent Users HO', value: String(this.maxConcurrentSession), status: 'A' }
        await HTTPRequest.postRequest(`${this.endPoint}/settings/update_setting_by_admin`, null, maxSessionParams)

        let accountRequest = await HTTPRequest.putRequest(`${this.endPoint}/accounts/${account_id}`, null, params) 

        if(accountRequest.error != undefined){
          this.$notification['error']({
            message: 'Error in updating account details',
            description: accountRequest.error
          });
        }else{
          this.$notification['success']({
            message: 'Successfully updated',
            description: "This account details has been updated."
          });
        }

        this.showDrawerViewDetails = false
      },
      async setCostingMethod(account_id){
          if(['LIFO', 'FIFO'].includes(this.currentCostingMethod) && (this.accountCredentials.documentCostingMethod == 'AVERAGE' || this.accountCredentials.documentCostingMethod == 'BLENDED')){
            this.$confirm({
              title: 'Confirmation',
              content: h => <div>Changing the costing method from <b>{this.currentCostingMethod}</b> to <b>{this.accountCredentials.documentCostingMethod}</b> will merge the inventory cost layer into the background process. Do you want to continue?</div>,
              okText: 'Yes',
              onOk: () => { this.processAverage(account_id, 1) },
              onCancel: () => {
                this.accountCredentials.documentCostingMethod = this.currentCostingMethod
              }
            });
          } else {
            this.processAverage(account_id, 0)
          }
        },
        async processAverage(account_id, action){
          if (action > 0){
            this.accountCredentials.costingStatus = 'Processing inventory cost layer. (From '+ this.currentCostingMethod +' To '+ this.accountCredentials.documentCostingMethod +')'
          } else {
            this.accountCredentials.costingStatus = '0'
          }
          
          //Tag account settings
          var settingPayload = { setting: 
                                {code: "accountSettings", name: "Account Settings", value: JSON.stringify(this.accountCredentials), status: 'A', account_id: account_id},
                         }
          var updatesettingRequest = await HTTPRequest.postRequest(this.endPoint + 'settings/update_setting_by_admin', null, settingPayload)
          var actionLog = 'From: ' +  this.currentCostingMethod + ' To: ' +  this.accountCredentials.documentCostingMethod;       
          if(updatesettingRequest.id > 0) {

            if (action > 0){
              this.$notification['success']({
                  message: 'Successful Operation',
                  description: "Merging of cost layer has been queued. You can check the ongoing jobs for updates.",
                  style: getNotificationStyle('success'),
                  btn: h => {
                      return h(
                      'base-button',
                      {
                          props: {
                          type: 'primary',
                          class: 'btn-sm',
                          },
                          on: {
                          click: () => this.$router.push("/jobs"),
                          },
                      },
                      'View Jobs',
                      );
                  },
              });
              this.$router.replace(this.backLink)
            } else {
              this.$notification['success']({
                  message: 'Successful Operation',
                  description: "Account setting has been saved."
              });
            }

            this.currentCostingMethod = this.accountCredentials.documentCostingMethod
            //this.showDrawerViewDetails = false
            this.createLogs({actionLog});
          } else {
            this.$notification['error']({
                message: 'Failed updating account settings.',
                description: updatesettingRequest.error
            });
          }
          
        },
        createLogs: async function (outputData) {
          const endPoint = `${this.endPoint}admin/create_admin_logs?feature=costing_method`;
          let data = { logs: { ...this.requestData, ...outputData } }
          HTTPRequest.postRequest(endPoint, null, data);
        },
      async setBillingType(account_id, billing_type_id, site_id){
        let site = await HTTPRequest.getRequest(`${this.endPoint}sites/${site_id}`, null)
        site = {...site, billing_type_id, is_admin:true}
        await HTTPRequest.putRequest(`${this.endPoint}sites/${site_id}`, null, site )
      },
      async getAccountTemplates(){
          const templates = await HTTPRequest.getRequest(this.endPoint + 'account_templates', null, null) 
          this.account_templates_list =  templates.data
      },
      getSelectedAccountTemplate(value){
         this.accountTemplate = value
      },
      getSelectedAccountType(value){
        this.accountType = value;
      },
      getSelectedATierNumber(value){
        this.tierNumber = value;
      },
      addAccount(){
        this.showDrawer = true
      },
      onClose(){
          this.showDrawer = false
          this.showDrawerViewDetails = false
      },
      async onLoadError(error) {
          console.log(error)
      },
      async onPaginationData(paginationData) {
          this.$refs.pagination.setPaginationData(paginationData);
      },
      onChangePage(page) {
          this.$refs.vuetable.changePage(page);
      },
      async getSystemBusinessType(){
       this.system_business_type_list = await HTTPRequest.getRequest(this.endPoint + '/system_business_types', null, null)  
      //  console.log(this.system_business_type_list)
      },
      getSelectedBusinessType(value){
          this.businessType = value;
      },
      getSelectedCostingMethod(value){
            this.accountCredentials.documentCostingMethod = value;
      },
      async showAccountDetails(id){
          var accountRequest = await HTTPRequest.getRequest(this.endPoint + '/accounts/' + id, null, null)  
          // bryan
          this.getSitePricing(id)
          this.selectedAccountType  = accountRequest.account_type_id !== null? accountRequest.account_type_id : ''
              let sites = accountRequest.sites.map((site) => {
              if(site.billing_type_id === null) site.billing_type_id = ''
              return site})
            accountRequest = {...accountRequest, sites}
          this.account = accountRequest
          this.showDrawerViewDetails = true
          this.companyName = accountRequest.company_name
          this.accountName = accountRequest.account_name
          this.selectedTierNumber = (accountRequest.tier_no === 0) ? null : accountRequest.tier_no;

          var accountSettings = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code&account_id=' + id , null)
            if(accountSettings != null){
              this.accountCredentials = JSON.parse(accountSettings.value);
              this.currentCostingMethod = JSON.parse(accountSettings.value)['documentCostingMethod'];
              this.allowNonHoProductSiteEditing = this.accountCredentials.allowNonHoProductSiteEditing ? 'true' : 'false'
              this.showOtherSitePricesInNonHoEdit = this.accountCredentials.showOtherSitePricesInNonHoEdit === false ? 'false' : 'true'
            }

          // Fetch max concurrent session setting
          var maxSessionSetting = await HTTPRequest.getRequest(this.endPoint + 'settings/max_concurrent_ho?field_name=code&account_id=' + id, null)
          this.maxConcurrentSession = maxSessionSetting != null ? parseInt(maxSessionSetting.value) : 5

          this.companyTinNumber = ""
          this.companyAddress = ""
          if(accountRequest.company != null){
            this.companyTinNumber = accountRequest.company.tin
            this.companyAddress = accountRequest.company.address
          }
      },
      async updateAccountStatus(id, status){
          var accountPayload = {
              account: {
                  status: status
              }
          }
          var accountRequest = await HTTPRequest.putRequest(this.endPoint + '/accounts/' + id, null, accountPayload)  
          
          if(accountRequest.error != undefined){
              this.$notification['error']({
                message: 'Error in suspending account',
                description: accountRequest.error
              });

          }else{
              if( status == 'S'){
                  this.$notification['success']({
                    message: 'Successfully suspended account',
                    description: "This account will be temporarily unaccessible to users. "
                  });
              } else {
                  this.$notification['success']({
                    message: 'Successfully activated account',
                    description: "This account will now be accessible for use."
                  });
              }
              
          }

          this.showDrawerViewDetails = false
          
      },
      async createAccount(){
          this.loading = true;
          // Do validations

          var valid = true;
          this.errors = [];
          this.errors.push(ValidateField.required('Company Name', this.companyName));
          this.errors.push(ValidateField.required('Account Template', this.accountTemplate));
           this.errors.push(ValidateField.required('Business Type', this.businessType));
          // this.errors.push(ValidateField.charMinAndMax('Company Name', this.companyName, 0, 100));
          this.errors.push(ValidateField.required('Account Name', this.accountName));
          this.errors.push(ValidateField.required('TIN Number', this.companyTinNumber));
          this.errors.push(ValidateField.required('Company Address', this.companyAddress));
          this.errors.push(ValidateField.required('First Name', this.firstName));
          this.errors.push(ValidateField.required('Last Name', this.lastName));
          this.errors.push(ValidateField.required('Contact Number', this.contactNumber));
          this.errors.push(ValidateField.required('Email Address', this.emailAddress));
          this.errors.push(ValidateField.required('Email Address Confirmation', this.emailAddressConfirmation));
          this.errors.push(ValidateField.required('Password', this.password));
          this.errors.push(ValidateField.required('Password Confirmation', this.passwordConfirmation));
          this.errors.push(ValidateField.required('Costing Method', this.accountCredentials.documentCostingMethod));
          this.errors.push(ValidateField.required('Account Type', this.accountType));
          this.errors.push(ValidateField.required('Tier Number', this.tierNumber));
          // console.log(this.errors)
          
          this.errors = this._.compact(this.errors);
          if(this.errors.length > 0 ){
              // this.errors = this._.compact(this.errors);
              var errorText = "";
              for(var a= 0; a < this.errors.length; a++){
                  errorText += " " + this.errors[a] + "."
              }
              this.$notification['error']({
                message: 'Missing required fields',
                description: errorText
              });
              valid = false
              this.loading = false;
          }

          if(this.companyName.length > 100){
              this.$notification['error']({
                message: 'Reached maximum character',
                description: 'Company name field should not exceed 100 characters'
              });
              valid = false
              this.loading = false;
          }

          if(this.emailAddress != this.emailAddressConfirmation){
              this.$notification['error']({
                message: 'Email addresses do not match',
                description: "Make sure you entered the correct email addresses"
              });
              valid = false
              this.loading = false;
          }

          if(this.password != this.passwordConfirmation){
              this.$notification['error']({
                message: 'Passwords do not match',
                description: "Make sure you entered the same password"
              });
              valid = false
              this.loading = false;
          }

          if(valid){
              // alert("Create account")
              // Create owner of a

              var accountPayload = { account: {
                                          company_name: this.companyName,
                                          account_name: this.accountName,
                                          business_type_id: this.businessType,
                                          telephone_no: this.contactNumber,
                                          account_type_id: this.accountType,
                                          status: "A",
                                          tier_no: this.tierNumber
                                      },
                                      company: {
                                          code: _.camelCase(this.companyName), name: this.companyName,
                                          status: "A", address: this.companyAddress, tin: this.companyTinNumber
                                      },
                                      site: {
                                          code:  _.camelCase(this.companyName) + "DEF", 
                                          name: "Default Site", status: "A",
                                          site_type_id: 1, tin: this.companyTinNumber 
                                      },
                                      user: {
                                          first_name: this.firstName, last_name: this.lastName, 
                                          email: this.emailAddress, password: this.password,
                                          name: this.firstName + " " + this.lastName,
                                          user_name: this.userName
                                          // user_name: _.lowerCase(this.firstName) + "_" + _.lowerCase(this.lastName)
                                      },
                                      account_template: this.accountTemplate
                                  }    
      
            var accountRequest = await HTTPRequest.postRequest(this.endPoint + '/accounts', null, accountPayload)   
            
            if (accountRequest.id) {
              var settingPayload = { setting: 
                            {code: "accountSettings", name: "Account Settings", value: JSON.stringify(this.accountCredentials), status: 'A', account_id: accountRequest.id},
                     }
              var settingRequest = await HTTPRequest.postRequest(this.endPoint + 'settings/create_setting_by_admin', null, settingPayload)

              if(settingRequest.id > 0) {
                  this.$notification['success']({
                      message: 'Successfully created account.',
                      description: "View account details for owner's login credentials"
                  });
                  this.showDrawer = false
                }

            } else {
                this.$notification['error']({
                    message: 'Failed to create account.',
                    description: accountRequest.error
                });
              }
              this.loading = false;
          }
      },
      async search() {
        this.apiURL = await this.endPoint + "/accounts?account_name=" + this.searchQuery
        this.$refs.vuetable.refresh()
      }
  }
}

</script>

<style>

.ant-collapse > .ant-collapse-item-active > .ant-collapse-header {
background-color: #32325d;
color: white;
}

/* bryan */
.account-type-container {
  display: flex;
  align-items: center;
}
.account-label-container{
  font-weight: bold;
  margin-right: 5px;
}

</style>
